import React, {Component} from 'react';
import {BeatLoader} from 'react-spinners';
import {Link} from 'react-router-dom';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import MonthDropdown from '../../../Misc/MonthDropdown';
import {_addNotification, _addNotificationError,getGradeNumberByText, getSchoolGrades, groupBy} from "../../../../server/util";
import { get,postWithHeadersResponse,postWithHeaders } from '../../../../server/actions'
import {Bar} from 'react-chartjs-2';
import { BASE_URL_1 } from '../../../../server/constants';
var _ = require('lodash');
const options={
    responsive: true,
    maintainAspectRatio: false,
    legend:{
        position:'top'
    },
    tooltips: {
        mode: 'label',
        callbacks: {
        label: function(tooltipItem, data) { 
        return data.datasets[tooltipItem.datasetIndex].label + ": " + numberWithCommas(tooltipItem.yLabel);
        }
        }
    },
    scales: {
        xAxes: [{
            stacked:true,
                ticks: {
                 fontSize: 9,
                 min:0
                }
               }],
        yAxes: [{
            stacked:true,
                ticks: {
                 fontSize: 9,
                 min:0
                }
               }]

             },
             plugins: {
               datalabels: {
                  display: true,
                  color: 'white',
                  font: { size: '10' },
               }
            }
}
var numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
let gradeList=[];
class FreeReduceRegularChart extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            currentIndex:0,
            schoolYearList:JSON.parse(sessionStorage.getItem('schoolYearsList')),
            lineChart : {
                labels: [],
                datasets: [
                  {
                    label: 'Free',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgb(208, 131, 68)',
                    borderColor: 'rgb(208, 131, 68)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgb(208, 131, 68)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 5,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgb(208, 131, 68)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                  },
                  {
                    label: 'Reduced',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(181, 213, 106, 1)',
                    borderColor: 'rgba(181, 213, 106, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(181, 213, 106, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 5,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(181, 213, 106, 1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                  },
                  {
                    label: 'Regular',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(132, 190, 214, 1)',
                    borderColor: 'rgba(132, 190, 214, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(132, 190, 214, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 5,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(132, 190, 214, 1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                  }
                ]
              }
        }
        this.initCurrentIndex=this.initCurrentIndex.bind(this);
        this.onChangeSchoolYear=this.onChangeSchoolYear.bind(this);
        this.getOrdersData=this.getOrdersData.bind(this);
    }
    componentWillMount=()=>{
        this.initCurrentIndex();
    }
    initCurrentIndex=()=>{
        let stateObj=this.state;
        let index= _.findIndex(stateObj.schoolYearList, function(sYear) { return sYear.schoolYear == sessionStorage.getItem('schoolYearValue') });
        this.setState({currentIndex:index},()=>{
         this.onChangeSchoolYear();
        });

    }
    onChangeSchoolYear=()=>{        
        this.getOrdersData()
    }
    componentWillReceiveProps=(nextProps)=> {
        if(this.props.schoolYear!=''){ 
            this.setState({schoolYearList:JSON.parse(sessionStorage.getItem('schoolYearsList'))},()=>{
                this.initCurrentIndex(); 
            })
        }
    }    
    getOrdersData=()=>{
        let currentSession=this.state.currentIndex==-1?undefined:this.state.schoolYearList[this.state.currentIndex];
        if(currentSession!=undefined){
            let yearMonth=currentSession.schoolYear;
        get('/dashboard/studentsEligibilty?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&yearMonth=' + yearMonth + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=').then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _lineChart=this.state.lineChart;
            _lineChart.labels=[];
            _lineChart.datasets[0].data=[];
            _lineChart.datasets[1].data=[];
            _lineChart.datasets[2].data=[];
            const gradeGroup=groupBy(gradeList,'value');
            (gradeList||[]).forEach(rec=>{
                const key=rec.value;
                const label=((gradeGroup[key]||[])[0]||{}).label;
                _lineChart.labels.push(label);               
                //if((orders[key]||{}).freeLunchEligible||0 >0)
                _lineChart.datasets[0].data.push(((orders[key]||{}).freeLunchEligible||0));
                //if((orders[key]||{}).reducedPriceEligible||0 >0)
                _lineChart.datasets[1].data.push(((orders[key]||{}).reducedPriceEligible||0));
                _lineChart.datasets[2].data.push((((orders[key]||{}).totalStudents||0)-(((orders[key]||{}).freeLunchEligible||0)+((orders[key]||{}).reducedPriceEligible||0))));
            });
            this.setState({ lineChart:_lineChart,loading: false          
            })            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
        }
        }
    
    render(){ 
        gradeList=getSchoolGrades(0,false);  
        let schoolSessionYear= this.state.schoolYearList==null?'':
        (this.state.schoolYearList[this.state.currentIndex==-1?0: this.state.currentIndex].name)    
        return(<div>
         <NotificationSystem ref="notificationSystem"/> 
         <div className="col-md-4">  
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>   
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                 <span className="panel-title" 
                style={{fontSize: '14px', fontWeight:'600'}}>
                 {'Lunch Eligibility' }</span>
                <div className="pull-right">
                {
                    this.state.currentIndex>0?<a href='javascript:void(0)'  className="btn-lt" onClick={()=>{
                        let cIndex=this.state.currentIndex;
                        cIndex=(cIndex-1)<0?0:(cIndex-1);
                        this.setState({currentIndex:cIndex},()=>{
                            this.onChangeSchoolYear();
                        })
                    }}><i className='fa fa-chevron-circle-left '></i></a>: <a className="btn-lt" disabled="disabled"><i className='fa fa-chevron-circle-left '></i></a>
                }
                {
                    this.state.currentIndex<(this.state.schoolYearList==null?[]:this.state.schoolYearList).length-1?<a href='javascript:void(0)' className="btn-gt" onClick={()=>{
                        let cIndex=this.state.currentIndex;
                        cIndex=(cIndex+1)>this.state.schoolYearList.length-1?this.state.schoolYearList.length-1:(cIndex+1);
                        this.setState({currentIndex:cIndex},()=>{
                            this.onChangeSchoolYear();
                        })
                    }} ><i className='fa fa-chevron-circle-right'></i></a>:<a className="btn-gt" disabled="disabled"><i className='fa fa-chevron-circle-right'></i></a>
                }   
                </div>
                <p className="panel-title" 
                style={{fontSize: '12px', fontWeight:'600'}}>
                 {'[School Year: '+schoolSessionYear +']' }</p>
            </div>
            <div className="panel-body" style={{padding:'0px'}}>                   
            <Bar data={this.state.lineChart} options={options} />
            </div>
            </div>
        </div>
        </div>)
    }
}
export default FreeReduceRegularChart


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/FreeReduceRegularChart.jsx